import { render, staticRenderFns } from "./ProductosAEntregar.vue?vue&type=template&id=be7dcb4e"
import script from "./ProductosAEntregar.vue?vue&type=script&lang=js"
export * from "./ProductosAEntregar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports